@if (!isAuthRoute) {
  <app-header />
}
<main>
  <router-outlet />
</main>
@if (!isAuthRoute) {
  <app-footer />
}
